/* -------------------------------------------------------------------------- */
/*                               Schema Customers                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const customer = new schema.Entity('customers', {}, { idAttribute: 'customerId' });
export const customers = new schema.Array(customer);
